import SignolUtils from "@src/utils/signolUtils";
import {
  aviationBvrs,
  shippingBvrs,
} from "../authObjectMocks/getIndustryProfileResp";

export const getManagerProfileResp = (currentUser) => {
  const isShipping =
    (currentUser?.metadata?.industry ||
      currentUser?.customer?.industry ||
      SignolUtils.getIndustry()) === "shipping";
  const shippingProfile = {
    appUser: {
      id: "3a93b6de-0aba-4e3c-aba4-fb488fc52e56",
      identityId: "8ff24746-ad19-4268-b0b0-229f5c3d83cc",
      createdAt: null,
      email: "chief123ard@signol.io",
      username: null,
      firstname: "Viktor",
      lastname: "Marinov",
      dataPrivacyAgreementSigned: true,
      address: "test",
    },
    customer: {
      id: "e69f307f-033c-419c-a205-4be53efa1cf2",
      name: "DemoLine",
      customerCode: "DEL",
      industry: "shipping",
      language: "en",
      preferredEventName: "opportunity",
      preferredEventNamePlural: "opportunities",
      periodLabel: "period",
      baselinePeriod: 3,
      reportingDelay: 9,
      enabledPredictions: true,
      targetPeriodDuration: "BIWEEKLY",
      baselineLastRefreshDate: 1733760956685,
      corporateEmails: "geronimo+customer_chr@signol.io",
      contractStartDate: new Date(
        new Date().getFullYear() - 2,
        new Date().getMonth(),
        10,
      ),
      contractEndDate: new Date(
        new Date().getFullYear() + 2,
        new Date().getMonth(),
        10,
      ),
      enrollmentType: null,
      isDeleted: false,
      quicksightDashboardId: "",
    },
    teams: [
      {
        id: "80f2087d-13b1-4c7c-b357-c44505b8bd5e",
        name: "CHRDefaultTeam",
        alias: "Default Team",
        createdAt: "2019-02-02T18:00:17.757Z",
        customerId: "e69f307f-033c-419c-a205-4be53efa1cf2",
        customerCode: "CHR",
        targetBehaviours: [
          ...shippingBvrs.map((b) => ({
            acronym: b.behaviourAcronym,
            name: b.behaviourName,
            behaviour_name: b.behaviourKey,
          })),
        ],
      },
      {
        id: "80f2087d-13b1-4c7c-b357-c44505b8bd5f",
        name: "CHRAdvancedTeam",
        alias: "Extra Team",
        createdAt: "2019-02-02T18:00:17.757Z",
        customerId: "e69f307f-033c-419c-a205-4be53efa1cf2",
        customerCode: "CHR",
        targetBehaviours: [
          ...shippingBvrs
            .filter((e, i) => i <= 2)
            .map((b) => ({
              acronym: b.behaviourAcronym,
              name: b.behaviourName,
              behaviour_name: b.behaviourKey,
            })),
        ],
      },
    ],
    behaviours: shippingBvrs,
    charities: [],
    managerMetadata: [],
  };
  const aviationProfile = {
    appUser: {
      id: "3a93b6de-0aba-4e3c-aba4-fb488fc52e56",
      identityId: "8ff24746-ad19-4268-b0b0-229f5c3d83cc",
      createdAt: null,
      email: "vlad@signol.io",
      username: null,
      firstname: "Alan",
      lastname: "Rogers",
      dataPrivacyAgreementSigned: true,
      address: "test",
    },
    customer: {
      id: "e69f307f-033c-419c-a205-4be53efa1cf2",

      customerCode: "DA",
      name: "Demo Air",
      industry: "aviation",
      language: "en",
      preferredEventName: "flight",
      preferredEventNamePlural: "flights",
      periodLabel: "month",
      baselinePeriod: 3,
      reportingDelay: 9,
      enabledPredictions: true,
      targetPeriodDuration: "MONTHLY",
      baselineLastRefreshDate: 1733760956685,
      corporateEmails: "geronimo+customer_vs@signol.io",
      contractStartDate: new Date(
        new Date().getFullYear() - 2,
        new Date().getMonth(),
        10,
      ),
      contractEndDate: new Date(
        new Date().getFullYear() + 2,
        new Date().getMonth(),
        10,
      ),
      enrollmentType: null,
      isDeleted: false,
      quicksightDashboardId: "",
    },
    teams: [
      {
        id: "80f2087d-13b1-4c7c-b357-c44505b8bd5e",
        name: "VSDefaultTeam",
        alias: "Virgil Default Team",
        createdAt: "2019-02-02T18:00:17.757Z",
        customerId: "e69f307f-033c-419c-a205-4be53efa1cf2",
        customerCode: "DA",
        targetBehaviours: [
          ...aviationBvrs
            .filter((e, i) => i <= 2)
            .map((b) => ({
              acronym: b.behaviourAcronym,
              name: b.behaviourName,
              behaviour_name: b.behaviourKey,
            })),
        ],
      },
      {
        id: "80f2087d-13b1-4c7c-b357-c44505b8bd5f",
        name: "VSSpecialTeam",
        alias: "Virgil Special Team",
        createdAt: "2019-02-02T18:00:17.757Z",
        customerId: "e69f307f-033c-419c-a205-4be53efa1cf2",
        customerCode: "DA",
        targetBehaviours: [
          ...aviationBvrs
            .filter((e, i) => i <= 2)
            .map((b) => ({
              acronym: b.behaviourAcronym,
              name: b.behaviourName,
              behaviour_name: b.behaviourKey,
            })),
        ],
      },
    ],
    behaviours: aviationBvrs,
    charities: [],
    managerMetadata: [],
  };
  const profile = isShipping ? shippingProfile : aviationProfile;
  console.log({ profile });
  return profile;
};
